import { Box, ListItemButton, ListItemText } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: '16px',
  backgroundColor: theme.palette.colors.selectedAndDetailBackground,
  marginTop: '-10px',
  '& .swipe': {
    width: 600,
    marginBottom: 10,
    [theme.breakpoints.down('md')]: {
      width: 344,
    },
  },
  '.swiper-pagination': {
    position: 'initial',
  },
  '.swiper-pagination-bullet-active': {
    color: theme.palette.colors.highlight,
    '--swiper-theme-color': theme.palette.colors.highlight,
  },
  '.swiper-pagination-bullet': {
    color: theme.palette.colors.selectedAndDetailBackground,
  },
}));

export const ButtonsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '8px',
  [theme.breakpoints.up('md')]: {
    gap: '16px',
  },
}));

export const LeafListItemButtonMobileStyled = styled(ListItemButton)(
  ({ theme }) => ({
    flex: 'unset',
    display: 'flex',
    width: '106px',
    height: '32px',
    backgroundColor: theme.palette.colors.highlight,
    borderRadius: '5px',
    justifyContent: 'center',
    '&.Mui-disabled': {
      backgroundColor: theme.palette.colors.off,
    },
    [theme.breakpoints.up('md')]: {
      width: '235px',
    },
  }),
);

export const LeafListItemTextMobileStyled = styled(ListItemText)(
  ({ theme }) => ({
    flex: 'unset',
    display: 'flex',
    width: '100%',
    height: '100%',
    color: theme.palette.colors.onIconsAndTextButtons,
    alignItems: 'center',
    justifyContent: 'center',
    '.MuiListItemText-primary': {
      fontSize: '20px',
      fontWeight: 'normal',
      [theme.breakpoints.up('md')]: {
        fontSize: '14px',
        fontWeight: 500,
      },
    },
  }),
);
